import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router";
import type { SearchHit } from "@shared/search.ts";
import { searchTrip } from "@shared/search.ts";
import { searchKindLabel } from "@shared/labels.ts";
import { search as searchApi } from "../../lib/api.ts";
import { useTrip } from "../../app/trip.tsx";

export function SearchPage() {
  const { trip, offline } = useTrip();
  const [params] = useSearchParams();
  const [q, setQ] = useState(params.get("q") ?? "");
  const [hits, setHits] = useState<SearchHit[]>([]);
  const [searched, setSearched] = useState(false);
  const [source, setSource] = useState<"live" | "pack">("live");

  async function run(query: string) {
    const needle = query.trim();
    if (needle.length < 2) {
      setHits([]);
      setSearched(false);
      return;
    }
    if (offline && trip) {
      setHits(searchTrip(trip, needle));
      setSource("pack");
      setSearched(true);
      return;
    }
    try {
      const r = await searchApi(needle);
      setHits(r.hits);
      setSource("live");
    } catch {
      setHits(trip ? searchTrip(trip, needle) : []);
      setSource("pack");
    }
    setSearched(true);
  }

  useEffect(() => {
    const initial = params.get("q")?.trim();
    if (!initial) return;
    void run(initial);
  }, [params, offline, trip]);

  return (
    <main className="page">
      <h1 className="serif">Search</h1>
      <search>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            void run(q);
          }}
        >
          <label className="field">
            Find a booking, place or note
            <input value={q} onChange={(e) => setQ(e.target.value)} type="search" autoFocus />
          </label>
          <button className="btn" type="submit">Search</button>
        </form>
      </search>
      {searched && source === "pack" ? <p className="muted">Searching the trip on this phone.</p> : null}
      {searched && hits.length === 0 ? <p className="muted">Nothing matched. Try a confirmation, place or flight number.</p> : null}
      {hits.map((hit) => (
        <Link key={hit.id} to={hit.href} className="card" style={{ display: "block", color: "inherit", textDecoration: "none", marginTop: 12 }}>
          <p className="kicker">{searchKindLabel(hit.kind)}</p>
          <p>{hit.title}</p>
          <p className="muted">{hit.subtitle}</p>
        </Link>
      ))}
    </main>
  );
}
